// src/components/ThemeProvider.tsx
import { useEffect } from "react"
import type { ReactNode } from "react"

type Theme = "light" | "dark" | "system"

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    // Only read the persisted theme — never fallback to system if user picked something
    const stored = (localStorage.getItem("theme") as Theme) ?? "system"
    applyTheme(stored)
  }, [])

  return children
}

function applyTheme(theme: Theme) {
  const root = document.documentElement
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches

  const useDark = theme === "dark" || (theme === "system" && prefersDark)

  if (useDark) root.classList.add("dark")
  else root.classList.remove("dark")
}
